import * as React from "react";
import { ButtonRadioInput } from "../ButtonInput";

export const BooleanInput = (props) => {
  const options = [
    {
      value: true,
      label: "Yes",
    },
    {
      value: false,
      label: "No",
    },
  ];
  return (
    <ButtonRadioInput
      options={options}
      overrides={{
        Button: {
          props: {
            overrides: {
              BaseButton: {
                style: getButtonStyles,
              },
            },
          },
        },
      }}
      {...props}
    />
  );
};

export const getButtonStyles = ({ $theme }) => {
  return {
    marginLeft: "0px",
    ":not(:last-of-type)": {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      marginRight: "1px",
    },
    ":last-of-type": {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
    [`@media screen and (max-width: ${$theme.breakpoints.medium - 1}px)`]: {
      flex: "1 1 0%",
    },
    [`@media screen and (min-width: ${$theme.breakpoints.medium}px)`]: {
      ":not(:first-of-type)": {
        marginLeft: 0,
      },
      ":not(:last-of-type)": {
        marginRight: "1px",
      },
    },
  };
};
